var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof ae2-2 !== "undefined") return resolve();
	__webpack_require__.l("https://achieving-excellence-ui.supplymgmt-strategic-direct-material-sour-prod-vpn.us.e15.c01.johndeerecloud.com/mf-manifest.json", (event) => {
		if(typeof ae2-2 !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "ae2-2");
}).then(() => (ae2-2));